import { gsap } from 'gsap';
import { EffectsList } from './EffectsList';

export class Effects {
  /**
   * @constructor
   * @class Effects
   * @classdesc Library of predefined effects to use with {@link https://greensock.com/docs/v3/GSAP/ GSAP}
   *
   * @see https://greensock.com/docs/v3/GSAP/gsap.effects
   */
  constructor() {
    this.effects = EffectsList;
    this._registerEffects();
  }

  /**
   * Register all custom effects to {@link https://greensock.com/docs/v3/GSAP/ GSAP}
   */
  _registerEffects() {
    this.effects?.forEach((effect) => {
      const { id, set, to, defaults, offScreen } = effect;

      gsap.registerEffect({
        name: id,
        defaults: { duration: 0.5, ...defaults },
        extendTimeline: true,
        effect: (targets, config) => {
          if (offScreen) gsap.set(targets, { x: (i, t) => this._setOffScreen(t, offScreen) });
          if (set) gsap.set(targets, { ...set });
          return gsap.to(targets, { ...to, ...config });
        },
      });
    });
  }

  /**
   * Sets the element offscreen before animating
   * @param {HTMLElement} el
   * @param {string} side Either 'left' or 'right'
   * @returns {number} Offset value in pixels
   */
  _setOffScreen(el, side) {
    switch (side) {
      case 'left':
        return this._getOffScreenLeft(el);
      case 'right':
        return this._getOffScreenRight(el);
    }
  }

  /**
   * Gets the left offset value
   * @param {HTMLElement} el
   * @returns {number} Offset value in pixels
   */
  _getOffScreenLeft(el) {
    const rect = el.getBoundingClientRect();
    return -rect.right;
  }

  /**
   * Gets the right offset value
   * @param {HTMLElement} el
   * @returns {number} Offset value in pixels
   */
  _getOffScreenRight(el) {
    const rect = el.getBoundingClientRect();
    return window.innerWidth - rect.left;
  }
}
